import { useState } from "react"
import LazyLoad from "react-lazyload"

const GameImage = ({ gameId, gameImg }) => {
  const [currentIndex, setCurrentIndex] = useState(0)
  const [loaded, setLoaded] = useState(false)

  if (gameImg) {
    return (
      <LazyLoad>
        <img src={gameImg} alt="Game" className="game-image loaded" />
      </LazyLoad>
    )
  }

  // Build URLs dynamically using both 0,2 and 0,3 substrings
  const substringLengths = [2, 3]

  const fallbackImages = substringLengths.flatMap((len) => {
    const baseApiUrl = `https://fgh.fun/json/resources/images/WLP/${gameId.substring(
      0,
      len
    )}/${gameId}`
    const dimensionApiUrl = `https://fgh.fun/json/resources/images/WLP/${gameId.substring(
      0,
      len
    )}/200x200/${gameId}`

    // Include all format variations
    return [
      `${baseApiUrl}.jpg`,
      `${baseApiUrl}.png`,
      `${baseApiUrl}.gif`,
      `${dimensionApiUrl}.jpg`,
      `${dimensionApiUrl}.png`,
      `${dimensionApiUrl}.gif`,
    ]
  })

  // Handle load and error fallback
  const handleImageError = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex + 1 < fallbackImages.length ? prevIndex + 1 : prevIndex
    )
  }

  const handleImageLoad = () => {
    setLoaded(true)
  }

  return (
    <LazyLoad>
      <img
        src={fallbackImages[currentIndex]}
        alt="Game"
        onError={handleImageError}
        onLoad={handleImageLoad}
        className={`game-image ${loaded ? "loaded" : ""}`}
      />
    </LazyLoad>
  )
}

export default GameImage
